
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from "vue-property-decorator";
import NotClothing from "./not-clothing.vue";
import OaClothingFgb from "./oa-clothing-fgb.vue";
import OaClothingOemorodm from "./oa-clothing-oemorodm.vue";
import PmcSupplier from "./pmc-supplier.vue";
import { getCustomSupplierType } from "@/service/supplier-meta/common/supplier-info-service";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import { Form } from "element-ui";
import { customSupplierTypeEnum } from "@/service/supplier-meta/enums/customSupplierTypeEnum";
import { FormModel } from "@/service/common/entity/FormModel";
@Component({
  components: {
    NotClothing,
    OaClothingFgb,
    OaClothingOemorodm,
    PmcSupplier,
  },
})
export default class DevInfo extends SupplierForm {
  form = {};
  customSupplierTypeEnum = customSupplierTypeEnum;
  get customSupplierType() {
    return getCustomSupplierType(
      this.isClothingCategory,
      this.submitData.factoryInfo?.supplyClassification,
      this.submitData.enterpriseInfo?.supplyType
    );
  }
  getFormRef() {
    return (this.$refs.subForm as SupplierForm).$refs.form as Form;
  }
  getFormData() {
    return (this.$refs.subForm as SupplierForm).getFormData();
  }
  patchFormData(fd: FormModel) {
    const com = this.$refs.subForm as SupplierForm;
    if (com) {
      com.patchFormData(fd);
    }
  }
}
